import React, {Component} from "react";
import Char from "../../../images/char.jpg";

class ObjectInBox extends Component{
    render(){
        return(
            <div className="breadcrumb-area">
                <h3>Objects in Box</h3>
                <div className="object-widget">
                    <ObjectCard />
                    <ObjectCard />
                    <ObjectCard />
                    <ObjectCard />
                    <ObjectCard />
                    <ObjectCard />
                </div>
            </div>
        )
    }
}

export default ObjectInBox;

export function ObjectCard(){
    return(
        <div className="object-card">
            <img src={Char} />
            <h4>Object Name</h4>
            <p className="sec-txt small-txt">Character Arata</p>
        </div>  
    )
}